import { c as _c } from "react/compiler-runtime";
import { QuickSearch } from '@/components/Organisms/Navigation/Desktop/QuickSearch/QuickSearch';
import { GlobalSearchContextProvider } from '@/contexts/GlobalSearchContext';
import { useNavigationContext } from '@/contexts/NavigationContext/NavigationContext';
import { TrackingCategory } from '@/services/Analytics/bnefAnalyticsSettings';
import type { FCl } from 'react-fc';
import styled from 'styled-components';
export const QuickSearchPanel: FCl = t0 => {
  const $ = _c(5);
  const {
    className
  } = t0;
  const {
    isDesktopQuickSearchVisible
  } = useNavigationContext();
  let t1;
  if ($[0] !== className || $[1] !== isDesktopQuickSearchVisible) {
    t1 = isDesktopQuickSearchVisible && <MenuOverlay className={className}><QuickSearch /></MenuOverlay>;
    $[0] = className;
    $[1] = isDesktopQuickSearchVisible;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <GlobalSearchContextProvider trackingCategory={TrackingCategory.Navigation}>{t1}</GlobalSearchContextProvider>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const MenuOverlay = styled.div`
    width: 100%;
    background-color: var(--cds-color-background);
    border-top: solid 1px var(--color-lines-subtleDivider);
    border-bottom: solid 1px var(--color-lines-subtleDivider);
    position: absolute;
    left: 0;
    color: var(--cds-color-text);
    z-index: var(--zIndex-navigationBar);
`;